import { deleteData, getData, patchData } from "src/utils/axios/serverHelper";
import config from "src/config";
import { AxiosRequestConfig } from "axios";
import { ResponseDto } from "src/dtos/common/responseDto";

import { PRD3040_R01Dto } from "./Dto_PRD3040_R01";
import { PRD3040_R01Filter } from "./Store_PRD3040_R01";

const baseUrl = `${config.apiUrl}/PRD3040_R01`;

// 통합 생산실적 조회 API (view 파라미터로 탭별 데이터 분기)
export const getPRD3040_R01Data = async (view: string, params: Partial<PRD3040_R01Filter>) => {
	const url = `${baseUrl}/search`;
	const requestParams = {
		compCd: params.compCd || undefined,
		workplaceCd: params.workplaceCd || undefined,
		itemCd: params.itemCd || undefined,
		productEmp: params.productEmp || undefined,
		startDate: params.startDate || undefined,
		endDate: params.endDate || undefined,
		brandCd: params.brandCd || undefined,
		view,
	};

    return await getData<ResponseDto<PRD3040_R01Dto[]>>(url, { params: requestParams });
};

// 통합 Excel 내보내기 API
export const exportPRD3040_R01Excel = async (view: string, params: Partial<PRD3040_R01Filter>) => {
	const url = `${baseUrl}/excel/search`;
	const requestParams = {
		compCd: params.compCd || undefined,
		workplaceCd: params.workplaceCd || undefined,
		itemCd: params.itemCd || undefined,
		productEmp: params.productEmp || undefined,
		startDate: params.startDate || undefined,
		endDate: params.endDate || undefined,
		brandCd: params.brandCd || undefined,
	};


	// view는 쿼리 파라미터로, 나머지는 body로 전송
    return await getData<ResponseDto<string>>(url, {
        params: { ...requestParams, view },
    });
};

// 하위 호환을 위한 기존 함수들 (deprecated)
export const getPRD3040_R01List = async (searchType: string, params: Partial<PRD3040_R01Filter>, listLength: number = 0) => {
	const url = `${baseUrl}/${searchType}`;
	const requestParams = {
		compCd: params.compCd || undefined,
		workplaceCd: params.workplaceCd || undefined,
		itemCd: params.itemCd || undefined,
		productEmp: params.productEmp || undefined,
		startDate: params.startDate || undefined,
		endDate: params.endDate || undefined,
		brandCd: params.brandCd || undefined,
		listLength,
		view: 'date'
	};

    return await getData<ResponseDto<PRD3040_R01Dto[]>>(url, { params: requestParams });
};
